import type { ConflitoNovaAlocacao } from "@/modules/recursos";
import { conflitoCoincidencia, conflitoIntro, conflitosCiencia } from "../equipe-obra.constants";
import { descreverCoincidencia, formatPeriodo, obraLabel } from "../equipe-obra.utils";
import type { ConflitosAlocacaoDialogProps } from "./types-conflitos-alocacao-dialog";

/** Agrupa por profissional, na ordem em que aparecem. */
function porProfissional(conflitos: ConflitoNovaAlocacao[]) {
  const grupos = new Map<string, { nome: string; conflitos: ConflitoNovaAlocacao[] }>();
  for (const conflito of conflitos) {
    const grupo = grupos.get(conflito.usuarioId) ?? { nome: conflito.profissional, conflitos: [] };
    grupo.conflitos.push(conflito);
    grupos.set(conflito.usuarioId, grupo);
  }
  return [...grupos.entries()];
}

export function useConflitosAlocacaoDialog({
  obra,
  conflitos,
  mostrarTrecho = false,
}: ConflitosAlocacaoDialogProps) {
  const grupos = porProfissional(conflitos);
  const obraNova = obraLabel(obra);

  return {
    grupos: grupos.map(([usuarioId, grupo]) => {
      const papeis = [
        ...new Set(grupo.conflitos.map((conflito) => conflito.nova.papel).filter(Boolean)),
      ].join(", ");

      return {
        usuarioId,
        testId: `conflitos-alocacao-${usuarioId}`,
        nome: grupo.nome,
        intro: conflitoIntro(papeis),
        conflitos: grupo.conflitos.map((conflito) => ({
          chave: `${conflito.nova.id}-${conflito.existente.id}`,
          obraAtual: obraLabel(conflito.existente.obra),
          periodoAtual: formatPeriodo(conflito.existente),
          obraNova,
          periodoNovo: formatPeriodo(conflito.nova),
          coincidencia: conflitoCoincidencia(
            conflito.existente.obra.codigo || obraLabel(conflito.existente.obra),
            mostrarTrecho ? descreverCoincidencia(conflito) : undefined,
          ),
        })),
      };
    }),
    ciencia: conflitosCiencia(obraNova, grupos.length > 1),
  };
}
